/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";
import { useTranslation } from "react-i18next";

// @mui material components
import Grid from "@mui/material/Grid";
// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Pricing page components
import FaqCollapse from "../FaqCollapse";

function Faq() {
  const [collapse, setCollapse] = useState(false);
  const { t } = useTranslation("pages");
  const faqItems = t("pricingFaq.items", { returnObjects: true });

  return (
    <MDBox mt={8}>
      <Grid container justifyContent="center">
        <Grid item xs={12} md={8}>
          <MDTypography variant="h2" align="center" fontWeight="bold" gutterBottom>
            {t("pricingFaq.title")}
          </MDTypography>
          <MDBox mb={2}>
            <MDTypography variant="body2" align="center" color="text">
              {t("pricingFaq.subtitle")}
            </MDTypography>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={10}>
          {faqItems.map((item, index) => (
            <FaqCollapse
              key={item.question}
              title={item.question}
              open={collapse === index}
              onClick={() => setCollapse(collapse === index ? false : index)}
            >
              {item.answer}
            </FaqCollapse>
          ))}
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default Faq;
